export default __webpack_public_path__ + "static/media/Armguards of the Valiant.e6359847.jpg";